import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { BranchOptionalPhoneNumber } from './branches/BranchOptionalPhoneNumber';
import { BranchQuestionFallback } from './branches/BranchQuestionFallback';
import { BranchSplitNameStep122 } from './branches/BranchSplitNameStep122';
import { BranchUseCase } from './branches/BranchUseCase';
import { ProductSetupUIBranch } from './branches/ProductSetupUIBranch';
import { ProductSetupUITrackConfirmation } from './branches/ProductSetupUITrackConfirmation';
const DefaultBranches = [BranchUseCase, BranchQuestionFallback];
const softwareSignupBranches = [...DefaultBranches, BranchOptionalPhoneNumber, BranchSplitNameStep122];
export const FlowBranches = {
  [Flow.Crm]: softwareSignupBranches,
  [Flow.Marketing]: softwareSignupBranches,
  [Flow.Sales]: [...softwareSignupBranches, ProductSetupUIBranch, ProductSetupUITrackConfirmation],
  [Flow.Service]: softwareSignupBranches,
  [Flow.CmsFree]: softwareSignupBranches
};
export const getFlowBranches = () => {
  return FlowBranches[getFlowKey()] || DefaultBranches;
};